import dlv from 'dlv';
import { ClaimUpdateRequest } from '../../../types/claim';
import { CurrencyCode } from '../../../types/currencyCode';
import { PaymentUpdateRequest } from '../../../types/payments';
import { PayInvoiceModalForm } from '../../payments/components/PayInvoiceModal';
import { PAYMENT_SPECIAL_FIELDS } from '../data/constants';
import {
	PaymentDirtyFields,
	PaymentFormValues,
} from '../formBuilders/getPaymentForm';
import { FormBuilder, FormShape } from '../types';
import {
	filterObjectByKeys,
	getPathsForForms,
	updateRequestBuilder,
} from '../utils';

const paymentUpdateBuilder = (
	dirtyFields: PaymentDirtyFields,
	formValues: PaymentFormValues | PayInvoiceModalForm,
	fields: FormShape<FormBuilder>,
	primaryFormName: string,
	timezone = 'America/Los_Angeles',
	currency: CurrencyCode,
) => {
	const paths = getPathsForForms(fields, primaryFormName);
	let updateObject = {} as PaymentUpdateRequest;
	paths.forEach((key) => {
		if (Object.keys(dlv(dirtyFields, key, {})).length > 0) {
			let newUpdatedObject;
			const currDirtyFields = { [key]: dlv(dirtyFields, key, {}) };
			const currFormValues = { [key]: dlv(formValues, key, {}) };
			const currFields = {
				[key]: dlv(fields, key, {}),
			} as FormShape<FormBuilder>;

			const amount = dlv(
				currFormValues,
				`${key}.${PAYMENT_SPECIAL_FIELDS.amount}`,
				'',
			);

			const amountCurrency = dlv(
				currFormValues,
				`${key}.${PAYMENT_SPECIAL_FIELDS.amountCurrency}`,
				'',
			);

			const policyLocator = dlv(
				currFormValues,
				`${key}.${PAYMENT_SPECIAL_FIELDS.policyLocator}`,
				'',
			);

			const policyholderLocator = dlv(
				currFormValues,
				`${key}.${PAYMENT_SPECIAL_FIELDS.policyholderLocator}`,
				'',
			);

			if (dirtyFields['payment']['policyholderLocator']) {
				updateObject.policyholderLocator = policyholderLocator;
			}
			if (dirtyFields['payment']['policyLocator']) {
				updateObject.policyLocator = policyLocator;
			}
			if (dirtyFields['payment']['amountCurrency']) {
				updateObject.amountCurrency = amountCurrency;
			}
			if (dirtyFields['payment']['amount']) {
				updateObject.amount = amount;
			}

			// add currency to update object always
			updateObject.amountCurrency = currency;

			const filteredCurrFormValues = {
				[key]: filterObjectByKeys(currFormValues[key], [
					PAYMENT_SPECIAL_FIELDS.amount,
					PAYMENT_SPECIAL_FIELDS.amountCurrency,
					PAYMENT_SPECIAL_FIELDS.policyLocator,
					PAYMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			const filteredCurrDirtyFields = {
				[key]: filterObjectByKeys(currDirtyFields[key], [
					PAYMENT_SPECIAL_FIELDS.amount,
					PAYMENT_SPECIAL_FIELDS.amountCurrency,
					PAYMENT_SPECIAL_FIELDS.policyLocator,
					PAYMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			newUpdatedObject = updateRequestBuilder<ClaimUpdateRequest>(
				filteredCurrDirtyFields,
				filteredCurrFormValues,
				currFields,
				key,
				timezone,
			);
			updateObject = { ...updateObject, ...newUpdatedObject };
		}
	});
	return updateObject;
};

export default paymentUpdateBuilder;
